module.exports = __webpack_public_path__ + "img/Potato.8e5c677b.svg";